window.$ = require("jquery")

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import IndexApp from '../components/index/index-app.vue'

Vue.use(VueAxios, axios)

$(document).ready(function() {
  $("#root_nav_link").addClass("active")

  new Vue({
    el: document.getElementById('app'),
    render: (h) => h(IndexApp)
  }).$mount()
})
